export enum EnumTpDesconto {
    SemDesconto = 0,
    DescontoValor = 1,
    DescontoPercentual = 2,
    DescontoValorAntecipacaoDiaCorrido = 3,
    DescontoPercentualAntecipacaoDiaCorrido = 4
}